












































import { Component, Mixins, Prop, Ref } from 'vue-property-decorator';
import { CreateLocationData } from '@/modules/backend/Dto/CreateLocationData';
import EditDialogWrapper from '@/layouts/EditDialogWrapper.vue';
import Mixin from '@/mixins/base';
import { LocationsModule } from '@/store/dashboard/locations/LocationsModule';
import { resolveModule } from '@/store';
import { ValidationObserver } from '@/plugins/vee-validate';

interface LocationType {
  name: string;
  title: string;
  icon: string;
}

@Component({
  mixins: [Mixin],
  components: {
    'edit-dialog-wrapper': EditDialogWrapper
  }
})
export default class LocationCreationDialog extends Mixins(Mixin) {
  private readonly locationsModule: LocationsModule = resolveModule(LocationsModule);

  @Ref('observer')
  private readonly observer!: ValidationObserver;

  private form = {
    name: '',
    icon: 'mdi-account'
  };

  @Prop({ required: true })
  private readonly buildingId!: number;

  private get iconList(): LocationType[] {
    return [
      {
        name: 'porch',
        title: String(this.$i18n.t('screens.rates.type.porch')),
        icon: 'mdi-home-account'
      },
      {
        name: 'office',
        title: String(this.$i18n.t('screens.rates.type.office')),
        icon: 'mdi-home-currency-usd'
      },
      {
        name: 'tech',
        title: String(this.$i18n.t('screens.rates.type.tech')),
        icon: 'mdi-home-assistant'
      }
    ];
  }

  private async create(): Promise<void> {
    this.observer.reset();

    if (await this.observer.validate()) {
      const payload = new CreateLocationData();
      payload.buildingId = Number(this.buildingId);
      payload.name = this.form.name;
      payload.icon = this.form.icon;
      await this.locationsModule.Create(payload);
    } else {
      throw new Error('Validation error');
    }
  }

  private clearForm(): void {
    this.observer.reset();
    this.form = {
      name: '',
      icon: 'mdi-home-account'
    };
  }

  private dialogOpenHandler(): void {
    this.clearForm();
  }
}
